import React, { useState } from "react";
import { FeedbackModal } from "./FeedbackModal";

export function FeedbackButton() {
  const [showModal, setShowModal] = useState(false);
  const [pulling, setPulling] = useState(false);

  const handleClick = () => {
    // setShowModal(true);        // uncomment to open internal feedback form
    window.open("https://gentell.freshdesk.com/support/solutions", "_blank", "noopener,noreferrer");
    setPulling(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        onAnimationEnd={() => setPulling(false)}
        className={`feedback-tab${pulling ? " is-pulling" : ""}`}
        aria-label="Feedback, opens Help Center in a new tab"
      >
        <i className="flaticon2-chat-1" aria-hidden="true"></i>
        <span className="feedback-tab-label">Feedback</span>
        <i className="fas fa-external-link-alt feedback-tab-ext" aria-hidden="true"></i>
      </button>

      <FeedbackModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
}
